<div class="flex-row" (click)="handleToggleClick()">
  <p *ngIf="label" text-large-regular class="full-width">{{ label }}</p>
  <bw-icon-legacy *ngIf="checked; else toggleOff" iconName="toggle-on" size="72"></bw-icon-legacy>
  <ng-template #toggleOff>
    <bw-icon-legacy iconName="toggle-off" size="72"></bw-icon-legacy>
  </ng-template>
</div>
